import { cardsData } from '@/mocks/home';

export default function SectionCards() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            吃瓜精选
          </h2>
          <p className="text-sm text-foreground-500">编辑精选 · 不容错过的热门爆料</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((item, i) => (
            <article key={i} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">{item.tag}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">{item.excerpt}</p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 group-hover:gap-2 transition-all cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
        <div className={`flex justify-center mt-6 ${cardsData.length < 8 ? '' : ''}`}>
          <div className="w-full bg-background-50 rounded-xl p-5 border border-background-200/70 flex items-center justify-center gap-2 text-sm text-foreground-500 cursor-pointer hover:border-primary-200 hover:text-primary-600 transition-colors">
            <i className="ri-more-line"></i>
            <span>加载更多吃瓜精选</span>
          </div>
        </div>
      </div>
    </section>
  );
}